module.exports = __webpack_public_path__ + "img/assessment-52.bb24877e.png";